import { isLocalOrDevEnv } from '@/utils/helpers/env.ts'
import type { DevModeFeatures } from '@/components/dev/const'

const DEFAULT_ENABLED_DEV_FEATURES: DevModeFeatures[] = ['UPLOAD_QR_CODE']

export const useSettingsDevStore = defineStore(
  'settingsDev',
  () => {
    const devModeEnabled = ref(false)
    const devShowSettings = ref(false)
    const devDebugEnabled = ref(false)
    const devModeFeatures = ref<DevModeFeatures[]>([])

    // be sure that DevMode only works on `local` or `dev` envs

    if (isLocalOrDevEnv()) {
      devModeFeatures.value = DEFAULT_ENABLED_DEV_FEATURES
      devShowSettings.value = false
      devModeEnabled.value = true
    } else {
      devShowSettings.value = false
      devModeEnabled.value = false
    }

    const isDevModeAllowed = computed(() => isLocalOrDevEnv())

    function canModeDev() {
      return isDevModeAllowed.value && devModeEnabled.value
    }

    function hasModeFeature(feature: DevModeFeatures) {
      return devModeFeatures.value.includes(feature)
    }

    function canModeFeature(feature: DevModeFeatures) {
      return canModeDev() && hasModeFeature(feature)
    }

    return {
      isDevModeAllowed,
      devModeEnabled,
      devShowSettings,
      devDebugEnabled,
      devModeFeatures,
      canModeFeature,
    }
  },
  { persist: true },
)

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSettingsDevStore, import.meta.hot))
}
